import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import PropTypes from 'prop-types';
import featureListIcon from '../../../Pages/TemplatePage/imageIcons/FeatureListIcon.png';

const FeatureList = ({ title, items = [], sx = {} }) => {
  return (
    <Box sx={{ mb: { xs: 3, sm: 4 }, ...sx }}>
      {title && (
        <Typography
          sx={{
            fontFamily: 'IBM Plex Sans, sans-serif',
            fontWeight: 600,
            fontSize: { xs: '1rem', sm: '1.125rem', md: '1.25rem' },
            lineHeight: 1.2,
            color: '#000000',
            mb: { xs: 1.5, sm: 2 },
          }}
        >
          {title}
        </Typography>
      )}
      <List sx={{ p: 0 }}>
        {items.map((item, index) => (
          <ListItem
            key={index}
            sx={{
              p: 0,
              mb: { xs: 1, sm: 1.25 },
              alignItems: 'flex-start',
            }}
          >
            <Box
              component="img"
              src={featureListIcon}
              alt="Check"
              sx={{
                width: { xs: 20, sm: 22, md: 24 },
                height: { xs: 20, sm: 22, md: 24 },
                objectFit: 'contain',
                mr: { xs: 1, sm: 1.25 },
                mt: 0.25,
                flexShrink: 0,
              }}
            />
            <Typography
              sx={{
                fontFamily: 'IBM Plex Sans, sans-serif',
                fontWeight: 400,
                fontSize: { xs: '0.875rem', sm: '0.9375rem', md: '1rem' },
                lineHeight: 1.5,
                color: '#3F3F3F',
                flex: 1,
              }}
            >
              {item}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

FeatureList.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  sx: PropTypes.object,
};

export default FeatureList;
